import { render } from "./ZoneWizardZoneDetailsStep.vue?vue&type=template&id=f8bff2e2&scoped=true"
import script from "./ZoneWizardZoneDetailsStep.vue?vue&type=script&lang=js"
export * from "./ZoneWizardZoneDetailsStep.vue?vue&type=script&lang=js"

import "./ZoneWizardZoneDetailsStep.vue?vue&type=style&index=0&id=f8bff2e2&scoped=true&lang=less"

import exportComponent from "/home/biktorgj/Projects/Linube Cloud/Server_and_UI/ui-prod-4.22/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f8bff2e2"]])

export default __exports__